/**
 * @generated SignedSource<<2100e79faedcea3499a33c5694748709>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ValidationRuleLibraryItemRefInput = {
  kind?: string | null;
  name?: string | null;
  rliType?: string | null;
  version?: string | null;
};
export type ConnectorComponentRefInput = {
  kind?: string | null;
  name?: string | null;
  version?: string | null;
};
export type RulePropertyInput = {
  externalObjectType: string;
  propertyName: string;
  propertyValue?: string | null;
  propertyValues?: ReadonlyArray<string | null> | null;
};
export type activateRuleMutation$variables = {
  categories?: ReadonlyArray<string | null> | null;
  connectorComponentRef: ConnectorComponentRefInput;
  description?: string | null;
  displayName?: string | null;
  generalProperties: ReadonlyArray<RulePropertyInput>;
  notificationProperties?: ReadonlyArray<RulePropertyInput | null> | null;
  provider?: string | null;
  resourceName: string;
  ruleLibraryItemRef: ValidationRuleLibraryItemRefInput;
  specificProperties?: ReadonlyArray<RulePropertyInput | null> | null;
};
export type activateRuleMutation$data = {
  readonly activateValidationRule: {
    readonly checkId: number | null;
    readonly checkStatus: string | null;
    readonly checkStatusMessage: string | null;
    readonly connectorComponentRef: {
      readonly kind: string | null;
      readonly name: string | null;
      readonly version: string | null;
    } | null;
    readonly containerId: number | null;
    readonly datastoreId: number | null;
    readonly description: string | null;
    readonly displayName: string | null;
    readonly name: string;
    readonly ownerRef: string;
    readonly provider: string | null;
    readonly rliType: string | null;
    readonly rliVersion: string | null;
    readonly ruleLibraryItemRef: {
      readonly kind: string | null;
      readonly name: string | null;
      readonly rliType: string | null;
      readonly version: string | null;
    } | null;
    readonly tableRef: string | null;
  };
};
export type activateRuleMutation = {
  response: activateRuleMutation$data;
  variables: activateRuleMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categories"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connectorComponentRef"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "displayName"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "generalProperties"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "notificationProperties"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "provider"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resourceName"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ruleLibraryItemRef"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "specificProperties"
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rliType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v14 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "categories",
        "variableName": "categories"
      },
      {
        "kind": "Variable",
        "name": "connectorComponentRef",
        "variableName": "connectorComponentRef"
      },
      {
        "kind": "Variable",
        "name": "description",
        "variableName": "description"
      },
      {
        "kind": "Variable",
        "name": "displayName",
        "variableName": "displayName"
      },
      {
        "kind": "Variable",
        "name": "generalProperties",
        "variableName": "generalProperties"
      },
      {
        "kind": "Variable",
        "name": "notificationProperties",
        "variableName": "notificationProperties"
      },
      {
        "kind": "Variable",
        "name": "provider",
        "variableName": "provider"
      },
      {
        "kind": "Variable",
        "name": "resourceName",
        "variableName": "resourceName"
      },
      {
        "kind": "Variable",
        "name": "ruleLibraryItemRef",
        "variableName": "ruleLibraryItemRef"
      },
      {
        "kind": "Variable",
        "name": "specificProperties",
        "variableName": "specificProperties"
      }
    ],
    "concreteType": "Rule",
    "kind": "LinkedField",
    "name": "activateValidationRule",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ownerRef",
        "storageKey": null
      },
      (v11/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rliVersion",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConnectorComponentRef",
        "kind": "LinkedField",
        "name": "connectorComponentRef",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v10/*: any*/),
          (v13/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RuleLibraryItemRef",
        "kind": "LinkedField",
        "name": "ruleLibraryItemRef",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          (v10/*: any*/),
          (v13/*: any*/),
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "checkStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "checkStatusMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "checkId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "datastoreId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "containerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tableRef",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "activateRuleMutation",
    "selections": (v14/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v7/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "activateRuleMutation",
    "selections": (v14/*: any*/)
  },
  "params": {
    "cacheID": "c94ffb330c10cd8c689406388f065d08",
    "id": null,
    "metadata": {},
    "name": "activateRuleMutation",
    "operationKind": "mutation",
    "text": "mutation activateRuleMutation(\n  $resourceName: String!\n  $displayName: String\n  $description: String\n  $provider: String\n  $categories: [String]\n  $ruleLibraryItemRef: ValidationRuleLibraryItemRefInput!\n  $connectorComponentRef: ConnectorComponentRefInput!\n  $generalProperties: [RulePropertyInput!]!\n  $specificProperties: [RulePropertyInput]\n  $notificationProperties: [RulePropertyInput]\n) {\n  activateValidationRule(resourceName: $resourceName, displayName: $displayName, description: $description, provider: $provider, categories: $categories, ruleLibraryItemRef: $ruleLibraryItemRef, connectorComponentRef: $connectorComponentRef, generalProperties: $generalProperties, specificProperties: $specificProperties, notificationProperties: $notificationProperties) {\n    name\n    displayName\n    description\n    provider\n    ownerRef\n    rliType\n    rliVersion\n    connectorComponentRef {\n      kind\n      name\n      version\n    }\n    ruleLibraryItemRef {\n      kind\n      name\n      version\n      rliType\n    }\n    checkStatus\n    checkStatusMessage\n    checkId\n    datastoreId\n    containerId\n    tableRef\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5ae4afc48cd3c3521fc8e272430b61c";

export default node;
